<template>
  <!-- icon -->
  <!-- <img alt="icon" src="../assets/icon.png" style="width: 100px" /> -->
  <!-- landing -->
  <div
    style="
      width: 100%;
      background-color: black;
      padding-top: 130px;
      padding-bottom: 75px;
    "
  >
    <span style="color: white; font-size: 80px">BE MOUNTAIN, MY FRIEND</span>
    <img
      alt="landing"
      src="../assets/landing.png"
      style="width: 90%; padding-top: 130px"
    />
  </div>
  <!-- intro -->
  <table id="intro" style="width: 100%; margin: 0 auto; padding: 30px">
    <tbody>
      <tr>
        <td style="width: 50%">
          <img alt="I" src="../assets/I.jpg" style="width: 60%" />
        </td>
        <td style="width: 50%" class="leftAlignTd bigText">
          <span><v-icon>mdi-account</v-icon> Tiancheng Ma (Felix)</span>
          <br />
          <br />
          <span><v-icon>mdi-email</v-icon> tianchengma9527@gmail.com</span>
          <br />
          <br />
          <span
            ><v-icon>mdi-school</v-icon> UC San Diego - Mathematics & Computer
            Science</span
          >
          <br />
          <br />
          <span><v-icon>mdi-briefcase</v-icon> Full Stack Developer</span>
          <br />
          <br />
          <span><v-icon>mdi-map-marker</v-icon> Chicago, USA</span>
          <br />
          <br />
          <span
            ><v-icon>mdi-linkedin</v-icon>
            <a
              href="https://www.linkedin.com/in/tiancheng-ma-b91465209/"
              style="color: #2c3e50"
              >Linkedin</a
            ></span
          >
          <br />
          <br />
          <span><v-icon>mdi-wechat</v-icon> makeTodayCreative</span>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- skills -->
  <div style="background-color: black">
    <span style="width: 100%; color: white">
      VISUAL
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      DESIGN
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      INTERACTIVE
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      ENGAGING
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      LOGICAL
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      SECURED
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      STRUCTURED
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      INDEXED
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      DELIVERY
      <svg width="12" height="12">
        <circle cx="6" cy="6" r="6" fill="#FF0000" />
      </svg>
      ACCESSIBLE
    </span>
  </div>
  <div>
    <img
      src="../assets/skills/figma.svg"
      alt="figma"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/modao.png"
      alt="modao"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/html.svg"
      alt="html"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/css-3.svg"
      alt="css"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/js.svg"
      alt="js"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/vue.svg"
      alt="vue"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/golang.svg"
      alt="golang"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/python.svg"
      alt="python"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/postgresql.svg"
      alt="postgresql"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/mysql.svg"
      alt="mysql"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/linux.svg"
      alt="linux"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/aws.svg"
      alt="aws"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/nginx.svg"
      alt="nginx"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/ssl.svg"
      alt="ssl"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/github.svg"
      alt="github"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
    <img
      src="../assets/skills/docker.svg"
      alt="docker"
      width="150px"
      height="150px"
      style="margin: 30px"
    />
  </div>
  <!-- projects -->
  <div style="width: 90%; margin: 0 auto">
    <v-card
      style="
        width: 30%;
        float: right;
        height: 30vh;
        margin-top: 5vh;
        margin-left: 1%;
        margin-right: 1%;
      "
    >
      <v-card-title
        >Howbuy Asset Management | AI Development Internship | Shanghai,
        China</v-card-title
      >
      <v-card-text>
        Worked on data cleaning to handle errors and check validation,
        generating Chinese data corpus for RAT-SQL (Text2SQL) training, and
        assisted in AI prediction features, enhancing model processing and
        boosting accuracy.
        <br />
        Developed an AI-powered chatbot using JavaScript, Python and Flask for
        real-time interactions.
      </v-card-text>
    </v-card>
    <v-card
      style="
        width: 30%;
        float: right;
        height: 30vh;
        margin-top: 5vh;
        margin-left: 1%;
        margin-right: 1%;
      "
    >
      <v-card-title
        ><a href="https://www.neuroleap.com">NeuroLeap Corp.</a> | Full Stack
        Developer | San Jose, CA</v-card-title
      >
      <v-card-text>
        Developed and managed the main website across teams and business owners,
        resulting in a 20% increase in product sales, marketing leads, and
        professional contacts.
        <br />
        Architected and refactored 6000+ lines of code using to deliver and
        improve scalable and responsive microservices
        <br />
        Created technical documentation on frontend and backend setup, API usage
        and deployment guidance.
      </v-card-text>
    </v-card>
    <v-card
      style="
        width: 30%;
        float: right;
        height: 30vh;
        margin-top: 5vh;
        margin-left: 1%;
        margin-right: 1%;
      "
    >
      <v-card-title
        ><a href="https://outlier.ai">Outlier </a> | AI Writing Evaluator
        USA</v-card-title
      >
      <v-card-text>
        Evaluated AI-generated responses for truthfulness and instruction
        following of topics from general knowledge to specialized and advanced
        subjects like mathematics and programming.
        <br />
        Identified and corrected errors in AI responses, enhancing content
        quality and reliability to improve AI models.
      </v-card-text>
    </v-card>
  </div>
  <div
    style="
      width: 100%;
      background-color: black;
      padding-top: 10%;
      padding-bottom: 10%;
      color: white;
    "
  ></div>
</template>

<script>
export default {
  name: "IntroPage",
};
</script>

<style scoped>
#intro {
  background-image: url("../assets/intro bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.leftAlignTd {
  text-align: left;
}
.bigText {
  font-size: 30px;
}
</style>
